import { render } from "./SystemValidationButtonSettingsView.vue?vue&type=template&id=22b9d739&scoped=true&ts=true"
import script from "./SystemValidationButtonSettingsView.vue?vue&type=script&lang=ts"
export * from "./SystemValidationButtonSettingsView.vue?vue&type=script&lang=ts"

import "./SystemValidationButtonSettingsView.vue?vue&type=style&index=0&id=22b9d739&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b9d739"]])

export default __exports__